<h2 mat-dialog-title>Confirmation</h2>
<mat-dialog-content>
  <p>{{message}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onConfirm()">Confirm</button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
